export default {
  methods: {
    // Makes <name> unique between different components, but not within a single
    // component scope
    uniqName(name) {
      return `${name}-${this._uid}`;
    }
  }
};
